import type { BaseParamsDto, IInsuranceParams } from './Step1'
import type { StepBase } from './StepBase'

export type InsuranceParamsTravelDto = {
    travel: TravelDto,
    addons: TravelAddonsDto
    baseParams?: BaseParamsDto
} & StepBase & IInsuranceParams

export type TravelDto = {
    range?: number
    destination?: number
    destinationEuropeCountry?: number
    travelType?: number
    reason?: number
    sportType?: number
    insuranceEndDate?: Date
    insurees: TravelInsuredDto[] | undefined
    areInsureesInFamily?: boolean
    destinationDescription?: string
    insurers?: number[] // pouze pro ucely rendrovani. Nepracuje se s nim na serveru
}

export type TravelInsuredDto = {
    uid?: string // pouze pro ucely rendrovani. Nepracuje se s nim na serveru
    firstName?: string
    lastName?: string
    birthdate?: Date | null
    birthnumber?: string
    isPolicyHolder: boolean
    isForeigner: boolean
}

export type TravelAddonsDto = {
    vehicleAssistanceAvailable: boolean,
    vehicleAssistanceRequired: boolean,
    vehicleRegistrationMark: string,
    vehicleFirstRegistrationDate?: Date,

    stornoInsuranceRequired: boolean,
    holidayPrice?: number,
    holidayPricePerPerson?: number,
    holidayPurchaseDate?: Date,
    holidayPaymentState?: number,

    covidInsuranceAvailable: boolean,
    covidInsuranceRequired: boolean,
    covidInsuranceCountryId?: number,
}

export type SaveStep2TravelRequest = {
    paramsId: string
    addons: TravelAddonsDto
}

/////////////// Default values ////////////////////

export const InitialTravelValues: TravelDto = {
    range: undefined,
    destination: undefined,
    destinationEuropeCountry: undefined,
    travelType: undefined,
    reason: undefined,
    sportType: undefined,
    insuranceEndDate: undefined,
    insurees: [],
    areInsureesInFamily: undefined
}

export const InitialTravelAddonValues: TravelAddonsDto = {
    vehicleAssistanceAvailable: false,
    vehicleAssistanceRequired: false,
    vehicleRegistrationMark: '',

    stornoInsuranceRequired: false,
    holidayPrice: undefined,
    holidayPricePerPerson: undefined,
    holidayPurchaseDate: undefined,

    covidInsuranceAvailable: false,
    covidInsuranceRequired: false
}